import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a tachograph icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TachographIcon width={12} />
 */
const TachographIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M36.604,25.272v3.772c0,0.692-0.566,1.257-1.257,1.257s-1.257-0.566-1.257-1.257v-3.772h-2.515v3.772c0,
            0.692-0.566,1.257-1.257,1.257c-0.692,0-1.258-0.566-1.258-1.257v-3.772h-5.03v15.09c0,1.396,1.119,2.502,2.515,
            2.502    l12.575,0.013c1.396,0,2.515-1.119,2.515-2.515v-15.09H36.604z M30.488,39.497c-1.481,
            0-2.686-1.205-2.686-2.686    c0-1.481,1.205-2.687,2.686-2.687c1.481,0,2.687,1.205,2.687,2.687C33.175,38.292,
            31.97,39.497,30.488,39.497z M35.685,41.393    L35.672,41.4c-0.415,0.269-0.97
            ,0.151-1.239-0.263l-0.009-0.014c-0.441-0.695-0.778-1.462-0.991-2.28    c0.4-0.578,0.637-1.278,
            0.637-2.033c0-0.755-0.236-1.455-0.637-2.034c0.213-0.817,0.55-1.584,0.991-2.279l0.009-0.014    c0.269-0.415,
            0.824-0.533,1.239-0.263l0.013,0.008c1.328,1.084,2.177,2.734,2.177,4.582    C37.862,38.659,37.013,40.309,
            35.685,41.393z`}
        />
        <path
            d={`M43.835,9.868H4.225c-1.21,0-2.201,0.99-2.201,2.201v13.203c0,1.21,0.99,2.201,2.201,
            2.201h17.68v-4.464h21.93v4.464    c1.21,0,2.201-0.99,2.201-2.201V12.068C46.035,10.858,45.045,9.868,43.835,
            9.868z M24.03,16.452c0,1.21-0.99,2.201-2.201,2.201    H6.425c-1.21,0-2.201-0.99-2.201-2.201v-2.201c0-1.21,
            0.99-2.201,2.201-2.201h15.404c1.21,0,2.201,0.99,2.201,2.201V16.452z`}
        />
    </SvgIcon>
)

TachographIcon.defaultProps = defaultProps

export { TachographIcon }
